import type { ActivityResponseDO } from "@/types/activity";

export const DEFAULT_ACTIVITY_STATS: ActivityResponseDO["stats"] = {
  checkInsToday: 0,
  checkInsInPeriod: 0,
  avgDailyCheckInsInPeriod: 0,
  avgDailyCheckIns7Days: {
    value: 0,
    percentageChange: "0%",
    changeType: "positive",
  },
};
